var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.is_displayed)?[_c('b-form',{staticClass:"mb-3"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }